import React from "react";
import FixedAssetInitialRecognitionsGenericSkeleton from "./FixedAssetInitialRecognitionsGenericSkeleton";

function FixedAssetInitialRecognitionsDetailSkeleton() {
  return (
    <>
      <FixedAssetInitialRecognitionsGenericSkeleton />
    </>
  );
}

export default FixedAssetInitialRecognitionsDetailSkeleton;
